import { fetch } from './http'
let http = ''
if (process.env.VUE_APP_APP_HOST) {
  http = process.env.VUE_APP_APP_HOST
} else {
  http = 'https://rsttest.vanke.com/tc03'
}
export const serversHttp = http
// 企业微信登录
export const qyWechatlogin = params => {
  return fetch('post', http + '/auth/qyWechatlogin/token', params, 'login')
  // return fetch('post', http + "/auth/qyWechatlogin/token?code=" + params.code + "&companyId=" + params.companyId, params, 'login');
}
// 获取用户信息
export const fetchUserInfo = params => {
  return fetch('get', http + '/admin/user/getUserInfo', params)
}
// 获取用户信息
export const loadOneInnstance = params => {
  return fetch(
    'post',
    http + '/bpmsmart/workFlowInstance/loadOneInnstance',
    params
  )
}
/**
 * 获取所有的数据字典(CODE)
 */
export const initDictWhenLogin = params => {
  return fetch('get', http + '/syscfg/dataDictionary/initDictWhenLogin', params)
}
/**
 * 合同新增其它费项下拉接口
 */
export const queryFeeCodeDataByCompanyIdForPage = params => {
  return fetch(
    'get',
    http + '/finance/finfeecodeapp/queryFeeCodeDataByCompanyIdForPage',
    params
  )
}
/**
 * 获取合同详情数据
 */
export const loadContractInfoById = params => {
  return fetch(
    'get',
    http + '/contract/contractapp/loadContractInfoById',
    params
  )
}
/**
 * 获取合同审批流抽屉合同内容
 */
export const loadContractCalDataByContPk = params => {
  return fetch(
    'get',
    http + '/contract/contractapp/loadContractCalDataByContPk',
    params
  )
}
// 审批流审核
export const doInstance = params => {
  return fetch('post', http + '/bpmsmart/workFlowInstance/doInstance', params)
}
/**
 * 合同退租初明细和草稿版本
 */
export const loadContractDraftInfoByContId = params => {
  return fetch(
    'get',
    http + '/contract/contractapp/loadContractDraftInfoByContId',
    params
  )
}
/**
 * 合同审批附件单独查询接口
 */
export const queryContractApproveAttachmentList = params => {
  return fetch(
    'get',
    http + '/syscfg/attachment/queryContractApproveAttachmentList',
    params
  )
}
/**
 * 获取图片附件
 */
export const queryAttachmentListByOneData = params => {
  return fetch(
    'get',
    http + '/syscfg/attachment/queryAttachmentListByOneData',
    params
  )
}
/**
 * 下载附件
 */
export const downLoadOneFile = params => {
  return fetch(
    'get',
    http + '/syscfg/attachmentTerminal/downLoadOneFile',
    params
  )
}
/**
 * test
 */
export const queryBpmFlowByBuildIds = params => {
  return fetch('get', http + '/syscfg/bpmSyscfg/queryBpmFlowByBuildIds', params)
}
/**
 * 意向协议详情
 */
export const loadIntentInfoById = params => {
  return fetch('get', http + '/contract/intentapp/loadIntentInfoById', params)
}
/**
 * 意向协议审批内容
 */
export const loadIntentCalDataByIntentPk = params => {
  return fetch(
    'get',
    http + '/contract/intentapp/loadIntentCalDataByIntentPk',
    params
  )
}
/**
 * 意向协议审批内容
 */
export const loadContractDraftInfoForApproveByContId = params => {
  return fetch(
    'get',
    http + '/contract/contractapp/loadContractDraftInfoForApproveByContId',
    params
  )
}
